import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface categoryProp {
	name: string;
	icon: string;
}

interface CategoryProductState {
	products: any[];
	categories: any[];
	brands: any[];
	activeCategory: categoryProp;
	brand: string[];
	minPrice: number;
	maxPrice: number;
	variant: string;
}

const initialState: CategoryProductState = {
	products: [],
	brands: [],
	categories: [],
	activeCategory: {
		name: "",
		icon: "",
	},
	brand: [],
	minPrice: 1000,
	maxPrice: 10000000,
	variant: "",
};

const categoryProductSlice = createSlice({
	name: "categoryProduct",
	initialState,
	reducers: {
		setProducts: (state, action: PayloadAction<any[]>) => {
			if (JSON.stringify(state.products) !== JSON.stringify(action.payload)) {
				state.products = action.payload;
			}
		},
		setCategory: (state, action: PayloadAction<categoryProp>) => {
			return {
				...state,
				activeCategory: action.payload,
			};
		},
		revertBrand: state => {
			return {
				...state,
				brand: [],
			};
		},
		revertVariant: state => {
			return {
				...state,
				variant: "",
			};
		},
		revertMinMax: state => {
			return {
				...state,
				minPrice: 1000,
				maxPrice: 10000000,
			};
		},
		setBrand: (state, action: PayloadAction<string>) => {
			const brand = action.payload;
			if (state.brand.includes(brand)) {
				state.brand = state.brand.filter(b => b !== brand);
			} else {
				state.brand.push(brand);
			}
		},
		setMinPrice: (state, action: PayloadAction<any>) => {
			state.minPrice = action.payload;
		},
		setMaxPrice: (state, action: PayloadAction<any>) => {
			state.maxPrice = action.payload;
		},
		setVariant: (state, action: PayloadAction<any>) => {
			return {
				...state,
				variant: action.payload,
			};
		},
		setCategories: (state, action: PayloadAction<any>) => {
			return {
				...state,
				categories: action.payload,
			};
		},
		setBrands: (state, action: PayloadAction<any>) => {
			return {
				...state,
				brands: action.payload,
			};
		},
	},
});

export const {
	setProducts,
	setCategory,
	setBrand,
	setMaxPrice,
	setMinPrice,
	setVariant,
	setCategories,
	setBrands,
	revertBrand,
	revertVariant,
	revertMinMax,
} = categoryProductSlice.actions;
export default categoryProductSlice.reducer;
